import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import usePost from 'core/hooks/api/usePost';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { InputText, InputNumber } from 'components/common/input';
import { validateForm } from 'core/utils/validation';
import useFormHandlers from 'core/hooks/form/useFormHandlers';
import { useInitialFetch } from 'core/context/initialFetchContext';

const FormWidget = ({ projectTitle, projectLink }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { postData } = usePost(API_ENDPOINTS.CONTACT);
  const { handleChange } = useFormHandlers(setFormData);
  const { storeInformation } = useInitialFetch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const validationRules = [
      { field: 'name', method: 'required' },
      { field: 'email', method: 'required' },
      { field: 'phone', method: ['required', 'validPeruPhone'] },
    ];
    const validationErrors = validateForm(formData, validationRules);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }
    const updatedFormData = {
      ...formData,
      phone: String(formData.phone),
      message: `${whatsappMessage}\n\n${formData.message}`
    };
    await postData(updatedFormData);
    setFormSubmitted(true);
    setIsSubmitting(false);
  };

  const whatsappMessage = `Hola, estoy interesado en un proyecto similar al de ${projectTitle} y me gustaría recibir asesoría para crear uno propio.\n` +
    `Puedes ver el proyecto aquí: ${projectLink}.`;

  return (
    <div className="widget ltn__form-widget">
      <h4 className="ltn__widget-title ltn__widget-title-border-2">¿Tienes un proyecto similar? ¡Contáctanos!</h4>
      {formSubmitted ? (
        <div id='product-pro-forma' className="form-submitted-message">
          <h5>Formulario enviado con éxito</h5>
          <p>Gracias por contactarnos. Nos pondremos en contacto con usted pronto.</p>
        </div>
      ) : (
        <form id="form-pro-forma" onSubmit={handleSubmit}>
          <InputText name="name" placeholder="Tu Nombre*" onChange={(e) => handleChange('name', e.target.value)} value={formData.name} error={errors.name} />
          <InputText name="email" placeholder="Tu Correo Electrónico*" onChange={(e) => handleChange('email', e.target.value)} value={formData.email} error={errors.email} />
          <InputNumber name="phone" placeholder="Tu Teléfono*" onChange={(e) => handleChange('phone', e.value)} value={formData.phone} error={errors.phone} />
          <textarea name="message" placeholder="Escribe tu mensaje..." onChange={(e) => handleChange('message', e.target.value)} value={formData.message} />
          <button type="submit" className="btn theme-btn-4" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                Enviando...
              </>
            ) : (
              'Enviar Mensaje'
            )}
          </button>
        </form>
      )}
      <a target="_blank" href={`https://wa.me/${storeInformation?.whatsapp}?text=${encodeURIComponent(whatsappMessage)}`} className="theme-btn-wsp btn mt-3" title="Contactar por WhatsApp">
        <i className="me-2 fab fa-whatsapp" />
        <span>Asesoria</span>
      </a>
    </div>
  );
};

export default FormWidget;
